import React, { useState } from 'react';
import { useMediaQuery, IconButton, List, ListItemText, ListItemButton, Box, SwipeableDrawer, styled, Collapse, ClickAwayListener, Menu, MenuItem, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import purpleLogo from '../assets/logo/logo-purple.png';
import './Header.css';
import { grey } from '@mui/material/colors';
import { CloseSharp, ExpandLess, ExpandMore } from '@mui/icons-material';
import { Link} from 'react-router-dom';
const Puller = styled('div')(({ theme }) => ({
  width: 30,
  height: 6,
  backgroundColor: grey[300],
  borderRadius: 3,
  position: 'absolute',
  top: 8,
  left: 'calc(50% - 15px)',
  ...theme.applyStyles('dark', {
    backgroundColor: grey[900],
  }),
}));


const Header: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [individualsSubmenuOpen, setIndividualsSubmenuOpen] = useState(false);
  const [desktopAnchorEl, setDesktopAnchorEl] = useState<null | HTMLElement>(null);
  const isMobile = useMediaQuery('(max-width: 991px)');

  const handleMenuToggle = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const handleIndividualsClick = () => {
    if (isMobile) {
      setIndividualsSubmenuOpen(!individualsSubmenuOpen);
    }
  };

  const handleDesktopMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setDesktopAnchorEl(event.currentTarget);
  };

  const handleDesktopMenuClose = () => {
    setDesktopAnchorEl(null);
  };

  const individualsSubmenuItems = [
    { text: 'Individuals', href: '/individuals' },
    { text: 'Pricing', href: '/individuals-pricing' },
  ];
  const menuItems = [
    { text: 'Individuals', href: '/individuals',
      hasSubmenu: true  },
    { text: 'Business', href: '/business' },
    { text: 'Industries', href: '/industries' },
    { text: 'Partner with us', href: '/partner' },
    { text: 'About us', href: '/about' },
  ];

  return (
    <header className="header">
      <Link to="/"><img src={purpleLogo} alt="EPAYR Logo" className="logo" /></Link>

      {isMobile ? (
        <>
          <IconButton
            aria-label="Open menu"
            onClick={handleMenuToggle}
            className="menu-button"
          >
            <MenuIcon />
          </IconButton>

          <SwipeableDrawer
            anchor="bottom"
            open={mobileMenuOpen}
            onOpen={handleMenuToggle}
            onClose={handleMenuToggle}
            PaperProps={{
              sx: {
                background: '#FFF',
                boxShadow: '0px 4px 2px 0px rgba(0, 0, 0, 0.05)',
                borderRadius: '12px 12px 0px 0px',
              }
            }}
          >
            <Puller />
            <Box sx={{
              display: 'flex',
              padding: '8px 12px 8px 20px',
              justifyContent: 'space-between',
              alignSelf: 'end'
            }}>
              <IconButton
                aria-label="Close menu"
                onClick={handleMenuToggle}
                sx={{
                  display: 'flex',
                  padding: '12px',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: "8px",
                  borderRadius: "14px",
                  backgroundColor: "gray.100",
                }}
              >
                <CloseSharp />
              </IconButton>
            </Box>
            <Box sx={{
              display: 'flex',
              alignItems: 'center',
              padding: '0px 30px 40px 30px',
              flexDirection: 'column',
              gap: '56px',
            }}>
              <List className='mobile-menu'>
                {menuItems.map((item, index) => (
                  <React.Fragment key={index}>
                  <ListItemButton 
                    component={item.hasSubmenu ? 'div' : Link} 
                    to={item.hasSubmenu ? undefined : item.href}
                    onClick={item.hasSubmenu ? handleIndividualsClick : handleMenuToggle}
                    className={item.hasSubmenu ? 'has-submenu' : ''}
                  >
                    <ListItemText>
                      <Typography variant='body7' sx={{
                        color: 'gray.400',
                        textTransform: 'uppercase',
                        }}>
                        {item.text}
                      </Typography>
                    </ListItemText>
                    {item.hasSubmenu && (
                      individualsSubmenuOpen ? <ExpandLess /> : <ExpandMore />
                    )}
                  </ListItemButton>
                  
                  {item.hasSubmenu && (
                    <Collapse in={individualsSubmenuOpen} timeout="auto" unmountOnExit>
                      <List component="div" disablePadding className="submenu-list">
                        {individualsSubmenuItems.map((subItem, subIndex) => (
                          <ListItemButton 
                            key={subIndex} 
                            component={Link} 
                            to={subItem.href}
                            sx={{ pl: 4 }}
                            className="submenu-item"
                            onClick={handleMenuToggle}
                          >
                           <ListItemText>
                          <Typography variant='body7' sx={{
                            color: 'gray.400',
                            textTransform: 'uppercase',
                            }}>
                            {subItem.text}
                          </Typography>
                        </ListItemText>
                          </ListItemButton>
                        ))}
                      </List>
                    </Collapse>
                  )}
                </React.Fragment>
                ))}
              </List>
              {/* <Button href='https://my.epayr.finance/' style={{
                width: '100%'
              }}>
                Sign In
              </Button> */}
              
            </Box>
          </SwipeableDrawer>
        </>
      ) : (<>
        <nav className="navigation">
          {menuItems.map((item, index) => (
            <React.Fragment key={index}>
              {item.hasSubmenu ? (
                <ClickAwayListener onClickAway={handleDesktopMenuClose}>
                  <div className="nav-item-container">
                    <div 
                      className="nav-item has-submenu" 
                      onClick={handleDesktopMenuOpen}
                      aria-controls={desktopAnchorEl ? "individuals-menu" : undefined}
                      aria-haspopup="true"
                    >
                      <span className="nav-text">{item.text}</span>
                      {desktopAnchorEl ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                    </div>
                    <Menu
                      anchorEl={desktopAnchorEl}
                      open={Boolean(desktopAnchorEl)}
                      onClose={handleDesktopMenuClose}
                      MenuListProps={{
                        'aria-labelledby': 'individuals-button',
                        sx: {
                          display: "flex",
                          minWidth: "160px !imporant",
                          flexDirection: "column",
                          alignItems: "flex-start",
                          gap: "4px",
                          padding: "8px 12px 8px 8px",
                          alignSelf: "stretch",
                        }
                      }}
                      slotProps={{
                        paper: {sx: {
                          mt: 1,
                          borderRadius: '8px',
                          boxShadow: '0px 4px 12px 0px rgba(50, 19, 56, 0.10)',
                        }}
                      }}
                    >
                      {individualsSubmenuItems.map((subItem, subIndex) => (
                        <MenuItem 
                          key={subIndex}
                          onClick={handleDesktopMenuClose}
                          component={Link}
                          to={subItem.href}
                          sx={{
                            display: "flex",
                            height: "40px",
                            padding: "0px 16px",
                            alignItems: "center",
                            gap: "8px",
                            alignSelf: "stretch",
                            "&:hover": {
                              backgroundColor: "lightPurple.200",
                            },      
                          }}
                        >
                          <Typography variant='body4' sx={{
                            color: "darkPurple.500",
                            textTransform: "uppercase",
                          }}>
                            {subItem.text}
                          </Typography>
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                </ClickAwayListener>
              ) : (
                <Link key={index} to={item.href} className="nav-item">
                  <span className="nav-text">{item.text}</span>
                </Link>
              )}
            </React.Fragment>
          ))}
        </nav>
        {/* {!isMobile && (
            <Button href='https://my.epayr.finance/' style={{
              alignSelf: 'right',
            }}>
              Sign In
            </Button>
          )} */}
          </>
      )}
    </header>
  );
};

export default Header;
